<template>
    <div class="virtual-stepper pb-75 border-bottom">
        <div class="row align-items-center">
            <div class="col-auto step" v-for="(step,index) in steps" :key="index" :class="{'active': index == value}">
                <div class="d-flex align-items-center pb-25">
                    <div class="step-number d-flex align-items-center text-white justify-content-center mr-1" :class="index == value ? `bg-${variant}`:'bg-light text-muted'">{{ index + 1 }}</div>
                    <div class="step-text mr-1 font-weight-bolder"  :class="index == value ? `text-${variant}`:'text-muted'">{{ step }}</div>
                    <feather-icon size="20" v-if="index != (steps || []).length - 1" class="text-muted step-arrow" icon="ChevronRightIcon"></feather-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        steps:{
            type:Array,
            default:()=>[]
        },
        value:Number,
        variant:{
            type:String,
            default:"primary"
        }
    }
}
</script>

<style>
.virtual-stepper .step-number{
    height: 2.71rem;
    width: 2.71rem;
    font-size: 1rem;
    border-radius: 6px;
    font-weight: bolder;
}

</style>